import axios from 'axios'

const request = {
  resolve (conf) {
    if (conf.method === 'get' || (conf.method === 'delete' && !conf.data)) { // 当delete需要通过body传惨的时候不走此项配置
      // 给config.data赋值, 使Content-type起作用
      conf.data = true
    }
    conf.headers['Content-Type'] = 'application/json;charset=UTF-8'
    return conf
  },
  reject (error) {
    // eslint-disable-next-line
    return Promise.reject('req', error);
  }
}

const response = {
  resolve (res = {}) {
    let rs = {
      status: '',
      data: res.data.data || null
    }
    if (res.status >= 200 && res.status < 300) {
      rs.status = 'OK'
    } else if (res.status >= 400) {
      rs.status = 'Fail'
    }
    return rs
  },
  reject (e) {
    let error = {}
    try { error = e.response.data.error || e.response.data } catch (err) {}
    return Promise.reject(
      (error.message || error.key)
    )
  }
}

class Api {
  constructor () {
    this.baseURL = 'http://yapi.smart-xwork.cn/mock/253454/config/'
  }
}
let api = axios.create(new Api())
api.interceptors.request.use(request.resolve, request.reject)
api.interceptors.response.use(response.resolve, response.reject)

export {
  api
}



// WEBPACK FOOTER //
// ./src/utils/apis.js